// Polling, throttle and toast durations shared across pages.

export const POLLING_INTERVAL_MS = 10_000;

export const HEALTH_POLL_MS = 30_000;

export const UPLOAD_THROTTLE_MS = 1_500;

// Longer than an info toast, shorter than a bulk undo: a copy is a single deliberate act the clerk
// is still looking at, and the Rückgängig has to outlive the paste it was made for.
export const COPY_TOAST_MS = 8000;
